import { Field } from "@fluentui/react-components";

import BodyPresenceMotion from "./BodyPresenceMotion";
import BaseOptionCombobox from "../../../../components/BaseOptionCombobox";

import { useDeviceDrawerStore } from "../../store/DeviceDrawerStore";
import { CategoryStateProps } from "../../hooks/useDeviceFormHook";

type StatusInfoProps = {
    styles: string;
    statusState: CategoryStateProps;
}

export default function StatusInfo({ styles, statusState }: StatusInfoProps) {
    const { isForward, level } = useDeviceDrawerStore();

    return (
        <BodyPresenceMotion
            isForward={isForward}
            visible={level === 4}
            unmountOnExit={true}
        >
            <div className={styles}>

                <Field label={"Status"} required={true} >
                    <BaseOptionCombobox
                        id={statusState.id}
                        data={statusState.list?.options}
                        defaultValue={statusState.value.toString()}
                        disabled={false}
                        onChange={statusState.setValue}
                    />
                </Field>

            </div>
        </BodyPresenceMotion>
    )
}